import React, { useEffect, useRef, useState } from "react";
import Attachments from "../../../../components/Attachments/Attachments";
import Notifications from "../../../../components/Notifications/Notifications";
import { IoMdNotificationsOutline } from "react-icons/io";
import { useStateValue } from "../../../../StateProvider";
import { useForm } from "react-hook-form";
import {
  ActivateUser,
  DeactivateUser,
  UserResetPassword,
  editeUser,
  getSignupReDetail,
  signup,
} from "../../../../apiCall";
import toast from "react-hot-toast";
import { DateToYYYYMMDD } from "../../../../utils/FormateDate";
import { NewPasswordModal } from "../../../../components/Modals/NewPasswordModal";
import { IoIosCloseCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Attachment from "../../../Attachment/Attachment";
import Notification from "../../../Notification/Notification/Notification";
import { validateNoBlankSpaces } from "../../../../utils/formValidation";

const UpdateStaff = ({
  userTypeOption,
  genderOption,
  setActiveTab,
  editUserData,
  handleConfirmationShow,
  setFunHandler,
  setNewUpdatedStaff,
  detailRefetch,
}) => {
  const [tab, setTab] = useState("information");
  const [, dispatch] = useStateValue();
  const [profileImage, setSetProfileImage] = useState("");
  const [profileError, setProfileError] = useState(false);
  const [isUserActivae, setIsUserActive] = useState();
  const [tranMID, setTranMID] = useState();

  const imageRef = useRef();
  const navigate = useNavigate();

  //******************************************attachment start **************************************************
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);

  const [isAddAttachments, setIsAddAttachments] = useState(false);
  const [isAddNotification, setIsAddNotification] = useState(false);

  const [title, setTitle] = useState("Update Staff");
  const formRef = useRef(null);
  const updateUrl = (newPath) => {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);

    // Construct new URL
    // const newPath = '/update/task/31';
    const newUrl = `${newPath}?${searchParams.toString()}`;

    // Navigate to the new URL
    navigate(newUrl);
  };

  const handleExternalSubmit = (submitType) => {
    if (tab === "information") {
      if (submitType === "attachments") {
        setIsAddAttachments(true);
      } else {
        setIsAddNotification(true);
      }
      if (formRef.current) {
        setTimeout(() => {
          formRef.current.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
          );
        }, 100);
      }
    } else if (submitType === "attachments") {
      setTab("attachments");
      setTitle("Update Staff");
    } else {
      setTab("notifications");
      setTitle("Update Staff");
    }
  };

  //******************************************attachment end **************************************************
  const activeUser = async (id) => {
    const re = await ActivateUser(id);
    if (re?.status === 200) {
      toast.success("success");
      setIsUserActive(true);
    } else if (re?.response) {
      toast.error("somthing went wrong.");
    }
  };
  const deactivateUser = async (id) => {
    const re = await DeactivateUser(id);
    if (re?.status === 200) {
      toast.success("success");
      setIsUserActive(false);
    } else if (re?.response) {
      toast.error("somthing went wrong.");
    }
  };
  const resetPassword = async (id) => {
    const re = await UserResetPassword(id);
    if (re?.status === 200) {
      toast.success("success");
      setNewPassword(re.data.status.new_password);
      handleShow();
    } else if (re?.response) {
      toast.error("somthing went wrong.");
    }
  };
  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = date.getUTCDate().toString().padStart(2, "0");
    const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    console.log(`${day}/${month}/${year}`);
    return `${year}-${month}-${day}`;
  }

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 300 * 1024) {
        // Show toast message
        toast.error("File size should be less than 300KB");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        // Once the file is read, set the Base64 string
        setValue("Photo", reader.result);
        setSetProfileImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });
  const onSubmit = async (data) => {
    console.log(data.RelvDt);
    if (data.RelvDt) {
      data.RelvDt = DateToYYYYMMDD(data.RelvDt);
    } else {
      delete data.RelvDt;
    }
    if (data.JoinDt) {
      data.JoinDt = DateToYYYYMMDD(data.JoinDt);
    } else {
      delete data.JoinDt;
    }
    data.BirthDt = DateToYYYYMMDD(data.BirthDt);
    dispatch({ type: "SET_LOADING", status: true });
    const re = await editeUser(editUserData?.LoginId, data);
    console.log(re);
    if (re?.status === 200) {
      if (isAddAttachments) {
        setTab("attachments");
        setIsAddAttachments(false);
      } else if (isAddNotification) {
        setTab("notifications");
        setTitle("Update Staff");

        setIsAddNotification(false);
      } else {
        setActiveTab("staffList");
        reset();
        setNewUpdatedStaff(data);
      }
      toast.success("Staff details changed successfully.");
    } else if (re?.response) {
      toast.error(re?.response?.data?.message);
    }
    dispatch({ type: "SET_LOADING", status: false });
  };

  useEffect(() => {
    if (editUserData) {
      setTranMID(editUserData?.ID);
      setValue("Code", editUserData?.Code);
      setValue("Name", editUserData?.Name);
      setValue("LoginId", editUserData?.LoginId);
      setValue("Photo", editUserData?.Photo);
      setSetProfileImage(editUserData?.Photo);
      setValue("Mobile", editUserData?.Mobile);
      setValue("EmailID", editUserData?.EmailID);
      setValue("Addr1", editUserData?.Addr1);
      setValue("Addr2", editUserData?.Addr2);
      setValue("Area", editUserData?.Area);
      setValue("City", editUserData?.City);
      setValue("Country", editUserData?.Country);
      setValue("Pincode", editUserData?.Pincode);
      setValue("Type", editUserData?.Type?.idx);
      setValue("Gender", editUserData?.Gender?.idx);
      setValue("BldGrp", editUserData?.BldGrp);
      setValue("AADHARNo", editUserData?.AADHARNo);
      setValue("BirthDt", formatDate(editUserData?.BirthDt));
      setIsUserActive(editUserData?.IsActive);
      setAttachmentCount(
        editUserData?.attachment_no ? editUserData?.attachment_no : 0
      );
      setNotificationCount(
        editUserData?.notifications_no ? editUserData?.notifications_no : 0
      );
      if (editUserData?.JoinDt) {
        setValue("JoinDt", formatDate(editUserData?.JoinDt));
      }
      if (editUserData?.RelvDt) {
        setValue("RelvDt", formatDate(editUserData?.RelvDt));
      }
    }
  }, [editUserData]);

  const [show, setShow] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const handleClose = () => {
    setShow(false);
    setNewPassword("");
  };
  const handleShow = () => setShow(true);
  const removeImage = () => {
    setValue("Photo", "");
    setSetProfileImage("");
  };
  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area mb-10">
        <div className="container-fluid ">
          <div className="mx-n6 mt-n6 pt-6 mb-6 header">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                {/* Page header */}
                <div
                  className="d-lg-flex
          align-items-center justify-content-between  px-6"
                >
                  <div className="mb-6 mb-lg-0">
                    <div className="d-flex align-items-center">
                      <div className="">
                        <h1 className="mb-0 h3 ">{title}</h1>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  {/* nav  */}
                  <ul className="nav nav-lb-tab px-6">
                    <li className="nav-item ms-0 me-3">
                      <div
                        role="button"
                        // className="nav-link active "
                        className={`${
                          tab === "information"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => {
                          setTab("information");
                          setTitle("Update Staff");
                        }}
                      >
                        Information
                      </div>
                    </li>
                    <li className="rounded-circl notification-count nav-item mx-3">
                      <div
                        role="button"
                        className={`${
                          tab === "attachments"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => {
                          handleExternalSubmit("attachments");
                        }}
                      >
                        Attachments
                      </div>
                      <div
                        className="notification-count d-flex justify-content-center"
                        style={{ top: "3px", right: "-14px" }}
                      >
                        {attachmentCount}
                      </div>
                    </li>
                    <li className="rounded-circl notification-count nav-item mx-3">
                      <div
                        role="button"
                        className={`${
                          tab === "notifications"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => {
                          handleExternalSubmit("notifications");
                        }}
                      >
                        Notifications
                      </div>
                      <div
                        className="notification-count d-flex justify-content-center"
                        style={{ top: "3px", right: "-14px" }}
                      >
                        {notificationCount}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              {/* Page header */}
              {/* <div className="mb-5">
                <h3 className="mb-0 ">Add Staff</h3>
              </div> */}
            </div>
          </div>
          <div>
            {/* row */}
            <div className="row">
              <div className="col-xl-12 col-md-12 col-12">
                {/* card */}
                {(() => {
                  switch (tab) {
                    case "information":
                      return (
                        <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
                          <div className="card mb-5">
                            {/* card body */}
                            <div
                              className="card-body"
                              style={{ padding: "10px" }}
                            >
                              {/* form */}
                              <div className="row">
                                {/* form group */}
                                <div className="mb-4 col-md-5 col-12">
                                  <label className="form-label">
                                    Code <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter code"
                                    disabled
                                    {...register("Code", {
                                      required: "Code is required",
                                      minLength: {
                                        value: 6,
                                        message:
                                          "Code requires at least 6 characters.",
                                      },
                                      validate: validateNoBlankSpaces,
                                      onChange: (event) => {
                                        setValue(
                                          "Code",
                                          event.target.value.toUpperCase()
                                        );
                                      },
                                    })}
                                  />
                                  {errors.Code && (
                                    <div className="error">
                                      {errors.Code.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-7 col-12">
                                  <label className="form-label">
                                    Name <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter name"
                                    {...register("Name", {
                                      required: "Name is required",
                                      validate: validateNoBlankSpaces
                                    })}
                                  />
                                  {errors.Name && (
                                    <div className="error">
                                      {errors.Name.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-5 col-6">
                                  <label className="form-label">Type</label>
                                  <select
                                    className="form-select"
                                    {...register("Type", {
                                      required: "Type is required",
                                    })}
                                  >
                                    <option value="">Set Type</option>
                                    {userTypeOption.map((item) => (
                                      <option value={item.id}>
                                        {item.value}
                                      </option>
                                    ))}
                                  </select>
                                  {errors.Type && (
                                    <div className="error">
                                      {errors.Type.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-3 col-6">
                                  <label className="form-label">
                                    Login Id{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    disabled
                                    placeholder="Enter login id"
                                    {...register("LoginId", {
                                      required: "Login Id is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  {errors.LoginId && (
                                    <div className="error">
                                      {errors.LoginId.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-2 col-12 d-flex align-items-end">
                                  <button
                                    type="button"
                                    className="btn btn-primary w-100 "
                                    onClick={() => {
                                      handleConfirmationShow();
                                      setFunHandler({
                                        fun: resetPassword,
                                        id: editUserData?.LoginId,
                                        title: "reset user password",
                                      });
                                      // resetPassword(editUserData?.LoginId)
                                    }}
                                  >
                                    Reset Password
                                  </button>
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-2 col-12 d-flex align-items-end">
                                  <div
                                    className="form-check form-switch mb-4"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <label
                                      className=""
                                      htmlFor="flexSwitchStock"
                                    >
                                      {isUserActivae ? (
                                        <strong>Active</strong>
                                      ) : (
                                        <strong>Deactive</strong>
                                      )}
                                    </label>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      id="flexSwitchStock"
                                      checked={isUserActivae}
                                      onClick={() => {
                                        if (isUserActivae) {
                                          handleConfirmationShow();
                                          setFunHandler({
                                            fun: deactivateUser,
                                            id: editUserData?.LoginId,
                                            title: "deactive user",
                                          });
                                        } else {
                                          handleConfirmationShow();
                                          setFunHandler({
                                            fun: activeUser,
                                            id: editUserData?.LoginId,
                                            title: "active user",
                                          });
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-5 col-12">
                                  <label className="form-label">
                                    Mobile{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter mobile"
                                    {...register("Mobile", {
                                      required: "Mobile is required",
                                      validate: validateNoBlankSpaces,
                                      pattern: {
                                        value: /^[0-9]{10}$/,
                                        message: "Invalid mobile number.",
                                      },
                                    })}
                                  />
                                  {errors.Mobile && (
                                    <div className="error">
                                      {errors.Mobile.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-7 col-12">
                                  <label className="form-label">
                                    Email <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter email"
                                    {...register("EmailID", {
                                      required: "Email ID is required",
                                      validate: validateNoBlankSpaces,
                                      pattern: {
                                        value:
                                          /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                                        message: "Invalid email address.",
                                      },
                                    })}
                                  />
                                  {errors.EmailID && (
                                    <div className="error">
                                      {errors.EmailID.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-7 col-12">
                                  <label className="form-label">
                                    Address{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control mb-2 "
                                    placeholder="Address line 1"
                                    {...register("Addr1", {
                                      // required: "Address line 1 is required",
                                    })}
                                  />
                                  {errors.Addr1 && (
                                    <div className="error">
                                      {errors.Addr1.message}
                                    </div>
                                  )}
                                  <input
                                    type="text"
                                    className="form-control mb-2 "
                                    placeholder="Address line 2"
                                    {...register("Addr2", {
                                      // required: "Address line 2 is required",
                                    })}
                                  />
                                  {errors.Addr2 && (
                                    <div className="error">
                                      {errors.Addr2.message}
                                    </div>
                                  )}
                                  <input
                                    type="text"
                                    className="form-control mb-2 "
                                    placeholder="Area"
                                    {...register("Area", {
                                      // required: "Area is required",
                                    })}
                                  />
                                  {errors.Area && (
                                    <div className="error">
                                      {errors.Area.message}
                                    </div>
                                  )}
                                  <input
                                    type="text"
                                    className="form-control mb-2 "
                                    placeholder="City"
                                    {...register("City", {
                                      // required: "City is required",
                                    })}
                                  />
                                  {errors.City && (
                                    <div className="error">
                                      {errors.City.message}
                                    </div>
                                  )}
                                  <div className="row">
                                    <div className=" col-md-6 col-12">
                                      <input
                                        type="text"
                                        className="form-control mb-2 "
                                        placeholder="Country"
                                        {...register("Country", {
                                          // required: "Country is required",
                                        })}
                                      />
                                      {errors.Country && (
                                        <div className="error">
                                          {errors.Country.message}
                                        </div>
                                      )}
                                    </div>
                                    <div className="mb-4 col-md-6 col-12">
                                      <input
                                        type="text"
                                        className="form-control mb-2 "
                                        placeholder="Pin code"
                                        {...register("Pincode", {
                                          // required: "Pincode is required",
                                        })}
                                      />
                                      {errors.Pincode && (
                                        <div className="error">
                                          {errors.Pincode.message}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-5 col-12">
                                  <label className="form-label">
                                    Picture{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <div className="d-flex justify-content-center align-items-center dropzone border-dashed min-h-0 rounded-2 dz-clickable">
                                    <div className="dz-default dz-message">
                                      <div className="dz-button" type="button">
                                        {!profileImage && (
                                          <div
                                            onClick={() =>
                                              imageRef.current.click()
                                            }
                                          >
                                            {" "}
                                            Upload Picture
                                          </div>
                                        )}

                                        {profileImage &&
                                          profileImage !== "" && (
                                            <div className="image-wrapper">
                                              <img
                                                src={profileImage}
                                                alt="Preview"
                                                style={{ width: "150px" }}
                                                onClick={() =>
                                                  imageRef.current.click()
                                                }
                                              />
                                              <div
                                                className="remove-img"
                                                onClick={() => removeImage()}
                                              >
                                                <IoIosCloseCircle size={20} />
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                      <input
                                        // disabled={!editStatus}
                                        type="file"
                                        ref={imageRef}
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        className="d-none"
                                      />
                                    </div>
                                  </div>
                                  {profileError && (
                                    <div className="error">
                                      Picture is required
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-6 col-6">
                                  <label className="form-label">
                                    Gender
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-select"
                                    {...register("Gender", {
                                      required: "Gender is required",
                                    })}
                                  >
                                    <option value="">Select Gender</option>
                                    {genderOption.map((item) => (
                                      <option value={item.id}>
                                        {item.value}
                                      </option>
                                    ))}
                                  </select>
                                  {errors.Gender && (
                                    <div className="error">
                                      {errors.Gender.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-6 col-6">
                                  <label className="form-label">
                                    Blood Group
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <select
                                    className="form-select"
                                    defaultValue={""}
                                    {...register("BldGrp", {
                                      // required: "Blood Group is required",
                                    })}
                                  >
                                    <option value="">Select Blood Group</option>
                                    <option value="O+">O+</option>
                                    <option value="AB+">AB+</option>
                                    <option value="B+">B+</option>
                                  </select>
                                  {errors.BldGrp && (
                                    <div className="error">
                                      {errors.BldGrp.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-6 col-6">
                                  <label className="form-label">
                                    Join Date{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="date"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon"
                                      {...register("JoinDt")}
                                      min="1000-01-01"
                                    />
                                  </div>
                                  {errors.JoinDt && (
                                    <div className="error">
                                      {errors.JoinDt.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-6 col-6">
                                  <label className="form-label">
                                    Reliev Date{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="date"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon3"
                                      min="1000-01-01"
                                      {...register(
                                        "RelvDt"
                                        // , {
                                        //   required: "Reliev Date is required",
                                        // }
                                      )}
                                    />
                                  </div>
                                  {errors.RelvDt && (
                                    <div className="error">
                                      {errors.RelvDt.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-6 col-12">
                                  <label className="form-label">
                                    Birth Date{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="date"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon3"
                                      min="1000-01-01"
                                      {...register("BirthDt", {
                                        required: "Birth Date is required",
                                      })}
                                    />
                                  </div>
                                  {errors.BirthDt && (
                                    <div className="error">
                                      {errors.BirthDt.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-6 col-12">
                                  <label className="form-label">
                                    Aadhar{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter aadhar number"
                                    {...register(
                                      "AADHARNo"
                                      // , {
                                      //   required: "Aadhar is required",
                                      // }
                                    )}
                                  />
                                  {errors.AADHARNo && (
                                    <div className="error">
                                      {errors.AADHARNo.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mt-4 mb-4 d-flex justify-content-between">
                            <div className="left d-flex flex-wrap gap-3">
                              <div
                                className="  btn btn-outline-danger me-2"
                                onClick={() => {
                                  setActiveTab("staffList");
                                  reset();
                                }}
                              >
                                Cancel
                              </div>
                              <div className="  rounded-circl notification-count">
                                <div
                                  className="btn btn-dark me-2"
                                  onClick={() =>
                                    handleExternalSubmit("attachments")
                                  }
                                >
                                  Attachments
                                </div>
                                <div className="notification-count d-flex justify-content-center">
                                  {attachmentCount}
                                </div>
                              </div>
                              <div className="  rounded-circl notification-count">
                                <div
                                  className="btn btn-dark me-2"
                                  onClick={() =>
                                    handleExternalSubmit("notifications")
                                  }
                                >
                                  Notifications
                                </div>
                                <div className="notification-count d-flex justify-content-center">
                                  {notificationCount}
                                </div>
                              </div>
                            </div>
                            <div className="right">
                              <button className="btn btn-primary  ">
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      );
                    case "attachments":
                      return (
                        <Attachment
                          setTab={setTab}
                          setAttachmentCount={setAttachmentCount}
                          setTitle={setTitle}
                          attachmentType={"staff"}
                          TranType={2}
                          AttchType={1}
                          staffId={editUserData?.ID}
                        />
                      );
                    case "notifications":
                      return (
                        <Notification
                          isStaffNotification={false}
                          setNotificationCount={setNotificationCount}
                          TranType={2}
                          TranMID={tranMID}
                          setTitle={setTitle}
                          detailRefetch={detailRefetch}
                          setTab={setTab}
                        ></Notification>
                      );
                    default:
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewPasswordModal
        show={show}
        onHide={handleClose}
        newPassword={newPassword}
        title="New Password"
      />
    </div>
  );
};

export default UpdateStaff;
